import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ClearIcon from '@material-ui/icons/Clear';
import cx from 'classnames';
import CircularLoading from 'components/base/loading/CircularLoading';
import T from 'components/common/text/T';
import { validInputString } from 'lib/library';
import { throttle } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { color } from 'styles/utils';

// 차후 필요시 multi select 추가
const AsyncFetchSelectWithAll = props => {
  const config = { ...props };
  let {
    inputProps,
    //
    className = '',
    minWidth,
    fullWidth,
    width,
    height,
    fontColor,
    placeholderColor,
    fontSize,
    borderColor,
    hoverBorderColor,
    activeBorderColor,
    bgColor,
    // hoverBgColor,
    loadingIconColor = color.blue,
    dropIconColor = '#707070',
    drondownHeight = '230px',
    disabled = false,
    testId,
  } = config;
  delete config.inputProps;
  const {
    // value = '',
    // setValue = () => {},
    existNameValue = '',
    fetchType = 'search', // search, fetch
    placeholder = '',
    defaultValue = '',
    hasInitialValue = false, // 초기 selectedLabel 값 유무 결정(All)
    initialValueName = '',
    selectedValue = '',
    setSelectedValue = () => {},
    setClientName = () => {},
    //
    data = [],
    hasMoreData = false,
    idKey = '',
    labelKey = '',
    exceptId = '',
    onFetch = () => {},
    searchLoading = null,
    onSearch = () => {},
    isInitValue = false,
    setIsInitValue = () => {},
  } = inputProps;

  const { t } = useTranslation();
  const inputRef = useRef(null);
  const VALUE_TYPE = 'INITIAL';

  const [inputValue, setInputValue] = useState(defaultValue);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [open, setOpen] = useState(null);
  const [cancelShow, setCancelShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isInit, setIsInit] = useState(isInitValue);
  const [isFocus, setIsFocus] = useState(false);

  useEffect(() => {
    setSelectedLabel(hasInitialValue ? initialValueName : '');
  }, [initialValueName]);

  const onChangeInput = (value, isInitial = false) => {
    setInputValue(value);
    if (fetchType === 'search') onSearch(!isInitial ? value : '');
  };

  const handleChangeInput = throttle(e => {
    const checkText = validInputString(e.target.value);
    // onChangeInput(e.target.value);
    onChangeInput(checkText);
    if (!!e.target.value) {
      setCancelShow(true);
    } else {
      handleCancel();
      setCancelShow(false);
    }
  }, 500);

  const checkKeyDown = e => {
    if (e.code === 'Enter') {
      setOpen(true);
    }
  };

  const handleFocusInput = e => {
    if (!!e.target.value) setCancelShow(true);
    setIsFocus(true);
  };

  const handleBlurInput = e => {
    setIsFocus(false);
  };

  useEffect(() => {
    if (isInitValue) {
      onChangeInput(selectedLabel, true);
      setSelectedLabel(selectedLabel);
      setSelectedValue('');
      setIsInitValue(false);
    }
  }, [isInitValue]);
  const handleCancel = () => {
    onChangeInput('');
    setSelectedValue('');
    setSelectedLabel('');
    inputRef.current.focus();
    setCancelShow(false);
  };

  const handleToggleDrop = () => {
    setOpen(!open);
  };

  const handleSelect = value => {
    const { e, id, type, initialValueName } = value;
    // focus first!
    inputRef.current.focus();
    if (type === VALUE_TYPE) {
      setSelectedLabel(initialValueName);
      // 중복 선택 방지
      if (initialValueName !== id) {
        // keyword: '' 로 검색
        onChangeInput(initialValueName, true);
        setSelectedValue(id);
      } else {
        onChangeInput(initialValueName, true);
      }
    } else {
      // 선택 시점 데이터를 기준으로 selectedLabel 설정
      const currentItem = data.find(item => item[idKey] === id);
      const currentName = !!currentItem ? currentItem[labelKey] : '';
      setSelectedLabel(currentName);

      // 중복 선택 방지
      if (selectedValue !== id) {
        onChangeInput(initialValueName);
        setSelectedValue(id);
      }
    }
    //
    setOpen(false);
    setCancelShow(true);
  };

  const handleBlurSelect = e => {
    const currentTarget = e.currentTarget;
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        if (!selectedValue && inputValue) {
          // 선택안한 상태, 검색하다 밖 클릭 -> 초기화
          onChangeInput('');
        }
        // 선택한 이후, 추가 단어 입력 하다가 밖 클릭 -> 검색이 됐던 단어로
        if (selectedLabel && inputValue && inputValue !== selectedLabel) {
          if (selectedLabel === initialValueName) {
            // initialValueName은 그대로 표시, keyword: ''로 검색 실행
            onChangeInput(initialValueName, true);
          } else {
            onChangeInput(initialValueName);
          }
        }

        setOpen(false);
        setCancelShow(false);
      }
    }, 0);
  };

  // SECTION: DidMount

  // 기본값 적용
  useEffect(() => {
    if (!existNameValue && data?.length && defaultValue) {
      const currentItem = data.find(item => item[idKey] === defaultValue);
      const currentName = !!currentItem ? currentItem[labelKey] : '';

      onChangeInput(currentName);
      setSelectedValue(defaultValue);
    }
    if (!!existNameValue && defaultValue) {
      onChangeInput(existNameValue);
      setSelectedValue(defaultValue);
    }
  }, [data, defaultValue]);

  useEffect(() => {
    if (!!selectedLabel) {
      setInputValue(selectedLabel);
      setClientName(selectedLabel);
    }
  }, [selectedLabel]);

  return (
    <StyledAsyncFetchSelectWithAll
      data-component-name="AsyncFetchSelectV2"
      {...config}
      // {...inputProps}
      className={`asyncFetchSelect ${className}`}
      tabIndex="1"
      onBlur={handleBlurSelect}
    >
      <input
        // disabled={Boolean(disabled)}
        type="text"
        ref={inputRef}
        // readOnly={fetchType === 'fetch'}
        placeholder={placeholder}
        // value={!!inputValue ? inputValue : t('GLOBAL_ALL')}
        value={!!isFocus ? inputValue : !!inputValue ? inputValue : t('GLOBAL_ALL')}
        onChange={handleChangeInput}
        onFocus={handleFocusInput}
        onClick={handleToggleDrop}
        onBlur={handleBlurInput}
        onKeyDown={checkKeyDown}
        className="AsyncFetchSelect__input"
        data-testid={`${testId}`}
      />

      {searchLoading ? (
        <span className="AsyncFetchSelect__loading">
          <CircularLoading size={13} color={loadingIconColor} />
        </span>
      ) : (
        <button className="AsyncFetchSelect__cancel" onClick={handleCancel}>
          <ClearIcon fontSize="inherit" htmlColor={dropIconColor} />
        </button>
      )}
      {/* {cancelShow && (
      )} */}
      {/* <button className="AsyncFetchSelect__cancel" onClick={handleCancel}>
        <ClearIcon fontSize="inherit" htmlColor={dropIconColor} />
      </button> */}
      {/* {!disabled && (
      )} */}
      <button
        className="AsyncFetchSelect__drop"
        onClick={handleToggleDrop}
        data-testid={`${testId}_drop`}
      >
        {!open ? (
          <ArrowDropDownIcon fontSize="inherit" htmlColor={dropIconColor} />
        ) : (
          <ArrowDropUpIcon fontSize="inherit" htmlColor={dropIconColor} />
        )}
      </button>
      {/* {!disabled && */}
      {open && (
        <div className="AsyncFetchSelect__dropdown_box">
          <InfiniteScroll
            className="infinite-scroll-box"
            dataLength={data?.length}
            next={onFetch}
            hasMore={hasMoreData}
            // next={() => {}}
            // hasMore={true}
            loader={
              <div className="infinite-scroll-loading">
                <CircularLoading />
              </div>
            }
            scrollThreshold={0}
            height={drondownHeight}
          >
            {hasInitialValue && (
              <div
                className="AsyncFetchSelect__dropdown_menu_item"
                onClick={e => handleSelect({ e, type: VALUE_TYPE, initialValueName, id: '' })}
              >
                {initialValueName}
              </div>
            )}
            {!!data?.length &&
              data.map((item, idx) => {
                if (exceptId && item[idKey] === exceptId) return;
                // console.log('item ______ ', item);
                return (
                  <div
                    key={idx}
                    // className="AsyncFetchSelect__dropdown_menu_item"
                    className={cx('AsyncFetchSelect__dropdown_menu_item', {
                      selected: defaultValue === item.userGroupIdx,
                    })}
                    onClick={e => handleSelect({ e, id: item[idKey], initialValueName: item.name })}
                  >
                    {item[labelKey]}{' '}
                    {item.accountType === 1 && (
                      <span className="sync_user">
                        <T>GLOBAL_SYNC</T>
                      </span>
                    )}
                  </div>
                );
              })}
          </InfiniteScroll>
        </div>
      )}
    </StyledAsyncFetchSelectWithAll>
  );
};

const StyledAsyncFetchSelectWithAll = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  min-width: ${({ minWidth }) => minWidth && minWidth};
  width: ${({ fullWidth }) => fullWidth && `100%`};
  width: ${({ width }) => width};
  // height apply, default height: 40px
  height: ${({ height }) => (height ? height : '40px')};
  color: ${({ fontColor }) => (fontColor ? fontColor : '#333')};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
  text-align: initial;
  input,
  button {
    all: unset;
  }
  &.xs {
    height: 24px;
    font-size: 12px;
    .AsyncFetchSelect__dropdown_box {
      top: 23px;
    }
  }
  &.sm {
    height: 32px;
    font-size: 12px;
    .AsyncFetchSelect__dropdown_box {
      top: 31px;
    }
  }
  &.md {
    height: 40px;
    font-size: 14px;
    .AsyncFetchSelect__dropdown_box {
      top: 39px;
    }
  }
  &.lg {
    height: 46px;
    font-size: 16px;
    .AsyncFetchSelect__dropdown_box {
      top: 45px;
    }
  }
  &.xl {
    height: 56px;
    font-size: 16px;
    .AsyncFetchSelect__dropdown_box {
      top: 55px;
    }
  }
  .AsyncFetchSelect__input {
    width: 100%;
    height: 100%;
    padding: 0 8px;
    padding-right: 55px;
    background-color: ${({ bgColor }) => (bgColor ? bgColor : '#fff')};
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-color: ${({ borderColor }) => borderColor};
    border-radius: 4px;
    &:hover {
      border-color: rgba(0, 0, 0, 0.87);
      border-color: ${({ hoverBorderColor }) => hoverBorderColor};
    }
    &:focus {
      border-color: ${color.blue};
      border-color: ${({ activeBorderColor }) => activeBorderColor};
    }
    &::placeholder {
      color: ${({ placeholderColor }) => placeholderColor || `rgba(0, 0, 0, 0.54)`};
    }
  }
  .AsyncFetchSelect__dropdown_box {
    z-index: 10;
    position: absolute;
    top: 39px;
    left: 0;
    width: 100%;
    /* padding: 5px 0; */
    max-height: ${({ drondownHeight }) => drondownHeight};
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    /* box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.16); */
    box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%),
      0px 3px 14px 2px rgb(0 0 0 / 12%);

    overflow-y: hidden;
    color: ${color.black_font};
    .AsyncFetchSelect__dropdown_menu_item {
      width: 100%;
      padding: 10px 8px;
      cursor: pointer;
      display: flex;
      &:hover {
        background-color: #ebebeb;
      }
      &.selected {
        background-color: #f6f4f4;
      }
    }
  }

  .AsyncFetchSelect__drop,
  .AsyncFetchSelect__cancel,
  .AsyncFetchSelect__loading {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .AsyncFetchSelect__loading {
    right: 58px;
  }
  .AsyncFetchSelect__cancel,
  .AsyncFetchSelect__drop {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      background-color: rgb(245, 245, 245, 0.23);
    }
  }
  .AsyncFetchSelect__cancel {
    right: 29px;
    font-size: 18px;
  }
  .AsyncFetchSelect__drop {
    right: 6px;
    font-size: 23px;
  }

  .sync_user {
    margin-left: 10px;
    background-color: #00a4e3;
    color: #fff;
    font-size: 11px;
    /* padding: 0 10px; */
    border-radius: 3px;
    letter-spacing: 0.11px;
    width: 45px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default React.memo(AsyncFetchSelectWithAll);
